export type AnimatedEmojiName = "geleng" | "hai" | "nunggu" | "selesai" | "tanya" | "kaca-pembesar" | "gembok" | "tiket" | "warning" | "silang";

const EMOJI_ALT: Record<AnimatedEmojiName, string> = {
	geleng: "Shaking head",
	hai: "Waving hand",
	nunggu: "Waiting",
	selesai: "Finished",
	tanya: "Questioning",
	"kaca-pembesar": "Magnifying glass",
	gembok: "Lock",
	tiket: "Ticket",
	warning: "Warning",
	silang: "Cross mark",
};

const EMOJI_SRC: Record<AnimatedEmojiName, string> = {
	geleng: "/static/geleng.webp",
	hai: "/static/hai.webp",
	nunggu: "/static/nunggu.webp",
	selesai: "/static/selesai.webp",
	tanya: "/static/tanya.webp",
	"kaca-pembesar": "/static/kaca-pembesar.webp",
	gembok: "/static/gembok.webp",
	tiket: "/static/tiket.webp",
	warning: "/static/warning.webp",
	silang: "/static/silang.webp",
};

export function AnimatedEmoji({
	name,
	size = 48,
	style,
}: {
	name: AnimatedEmojiName;
	size?: number;
	style?: React.CSSProperties;
}) {
	return (
		<img
			src={EMOJI_SRC[name]}
			alt={EMOJI_ALT[name]}
			width={size}
			height={size}
			style={{ display: "block", ...style }}
		/>
	);
}
